/**
 *
 * Sticky Current Keyword (JS)
 *
 * @author Space-Time Inc.
 * @version 2020-03-26
 *
 */

document.addEventListener('DOMContentLoaded', () => {


	const keywordElements
	= document.querySelectorAll(".tab-page .stile-tab-page-tab-list li");
	if ( ! keywordElements.length ) return;

	const stickedElements
	= document.querySelectorAll(".tab-page .left .inner-for-sticky");
	if ( ! stickedElements.length ) return;

	const wrapperElements
		= document.querySelectorAll(".tab-page .left");
	if ( ! wrapperElements.length ) return;

	const pageElements
		= document.querySelectorAll(".tab-page > div");
	if ( ! pageElements.length ) return;

	const neighborElements
		= document.querySelectorAll(".tab-page .right");
	if ( ! neighborElements.length ) return;

	const headerElement
	= document.querySelector(".st-sticky-header-top");
	if ( headerElement === null ) return;


	const KeywordNum = keywordElements.length;
	if ( stickedElements.length  != KeywordNum ) return;
	if ( wrapperElements.length  != KeywordNum ) return;
	if ( pageElements.length     != KeywordNum ) return;
	if ( neighborElements.length != KeywordNum ) return;

	//WordPress管理者用バー分のオフセット取得のため
	const wpadminbarElement = document.getElementById("wpadminbar");

	const breakPoint             = 900;  // 2段から1段に変化する横幅(px)
	const disappearAdminBarPoint = 600;  // admin barが消える幅(px)
	const offsetYDefault         = 0;  // 固定するコンテンツの画面トップからフィックスする距離(px)

	let offsetY;              // 実際に固定するY位置

	initFn();
	scrollFn(true);


	window.addEventListener("scroll", () => {
		scrollFn();
	}, { passive: true });
	if ("ontouchstart" in window) {
		window.addEventListener("touchmove", () => {
			scrollFn();
		}, { passive: true });
	}
	window.addEventListener("resize", () => {
		initFn();
		scrollFn(true);
	}, { passive: true });

	for (let i = 0 ; i < KeywordNum; i++) {
		keywordElements[i],addEventListener("click" , () =>{
			scrollFn();
		}, { passive: true });
	}


	function initFn() {

		const innerWidth = document.documentElement.clientWidth;

		let offsetByWpadminbar;
		if ( wpadminbarElement === null || disappearAdminBarPoint > innerWidth ){
			offsetByWpadminbar = 0;
		} else {
			offsetByWpadminbar = parseFloat(wpadminbarElement.clientHeight);
		}

		offsetY = offsetYDefault + offsetByWpadminbar + headerElement.getBoundingClientRect().height; // 実際に固定するY位置



		for (let i = 0; i < KeywordNum ; i++ ){
			if (breakPoint > innerWidth) {
				wrapperElements[i].style.height = stickedElements[i].getBoundingClientRect().height + "px";
			} else {
				wrapperElements[i].style.height = '';
			}
		}


	}



	function scrollFn(offsetXCheck = false) {
		const innerWidth = document.documentElement.clientWidth;

		let startYSticky         = []; // 位置調整を始めるY位置
		let stopYonSidebarBottom = []; // サイドバー底に止めるY位置

		const startScrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
		for (let i = 0; i < KeywordNum ; i++ ){

			let sticked_original_top;
			let sidebar_bottom;

			if (breakPoint > innerWidth) {
				sticked_original_top = pageElements[i].getBoundingClientRect().top + startScrollTop;
				sidebar_bottom       = pageElements[i].getBoundingClientRect().bottom + startScrollTop;
			} else {
				sticked_original_top = neighborElements[i].getBoundingClientRect().top + startScrollTop;
				sidebar_bottom       = pageElements[i].getBoundingClientRect().bottom + startScrollTop;
			}

			if ( sticked_original_top - offsetY > 0  ){
				startYSticky.push( sticked_original_top - offsetY ); //位置調整を始めるY位置
			} else {
				startYSticky.push( 0 ); //位置調整を始めるY位置
			}

			if ( sidebar_bottom - stickedElements[i].getBoundingClientRect().height - offsetY > 0 ){
				stopYonSidebarBottom.push( sidebar_bottom - stickedElements[i].getBoundingClientRect().height - offsetY ); //サイドバー底に止めるY位置
			} else {
				stopYonSidebarBottom.push( 0 ); //位置調整を始めるY位置
			}

		}


		// 現時点のページトップからのスクロール距離(Current Scroll Top)
		const cst = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

		// 現時点の固定するコンテンツのX軸位置 (Current OffsetX )
		let cox = [];
		// 現時点の固定するコンテンツの横幅 (Current Width )
		let cw =  [];


		for (let i = 0; i < KeywordNum ; i++ ){
			cox.push(stickedElements[i].getBoundingClientRect().left);
			cw.push(stickedElements[i].getBoundingClientRect().width);

			resetStyleOfStickedElement(stickedElements[i]);

			if ( startYSticky[i] === stopYonSidebarBottom[i] ) continue;

			if ( startYSticky[i] < cst && cst < stopYonSidebarBottom[i] ) {

				if (offsetXCheck) {
					stickedElements[i].style.transform = "translateY(" + (cst - startYSticky) + "px)";
					cox[i] = stickedElements[i].getBoundingClientRect().left;
					cw[i]  = stickedElements[i].getBoundingClientRect().width;
				}
				stickedElements[i].style.transform = "";
				stickedElements[i].style.position  = 'fixed';
				stickedElements[i].style.top       = offsetY + 'px';
				stickedElements[i].style.left      = cox[i] + 'px';
				stickedElements[i].style.width     = cw[i] + 'px';
				stickedElements[i].style.margin    = 'auto';

			} else if (stopYonSidebarBottom[i] < cst) {
				stickedElements[i].style.transform = "translateY(" + (stopYonSidebarBottom[i] - startYSticky[i]) + "px)";
			}

		}

	}


	function resetStyleOfStickedElement(e) {
		e.style.position  = 'relative';
		e.style.transform = '';
		e.style.top       = '';
		e.style.left      = '';
		e.style.width     = '';
		e.style.margin    = '';
	}

});
